// src/table/mergeRows.ts
function mergeStreamedRows(streamed, fetched, rowKey, max = 1e3) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const row of [...streamed, ...fetched]) {
    const key = rowKey(row);
    if (key !== null) {
      if (seen.has(key)) continue;
      seen.add(key);
    }
    out.push(row);
    if (out.length >= max) break;
  }
  return out;
}

export { mergeStreamedRows };
//# sourceMappingURL=chunk-WGEOMVHI.js.map
//# sourceMappingURL=chunk-WGEOMVHI.js.map